"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import { usePathname } from "next/navigation";

export function ThemeProvider({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();

    const shouldForceDark = !pathname.startsWith("/dashboard") && !/^\/[a-z]{2}\/dashboard/.test(pathname);

    return (
        <NextThemesProvider
            attribute="class"
            disableTransitionOnChange
            forcedTheme={shouldForceDark ? "dark" : undefined}
            defaultTheme="dark"
        >
            {children}
        </NextThemesProvider>
    );
}
